import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import creditCardType, { types as CardType } from 'credit-card-type';

interface PaymentProfile {
  card_number_first_six: string | number;
  card_number_last_four: string | number;
  card_expiration: string | number;
}

interface CardTypeData {
  niceType: string;
  type: string;
  gaps: number[];
  lengths: number[];
  code: { name: string, size: number };
}

@Component({
  selector: 'unh-payment-profile-card',
  templateUrl: './payment-profile-card.component.html',
  styleUrls: ['./payment-profile-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentProfileCardComponent {
  @Input() paymentProfile: PaymentProfile;

  get cardTypeData(): CardTypeData {
    const firstsix = this.paymentProfile && this.paymentProfile.card_number_first_six;
    const cardType = firstsix && creditCardType(firstsix)[0];
    return cardType;
  }
}
